module.exports = __webpack_public_path__ + "static/media/laurette-fugain.b1b60ea4.png";